import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import './LoginStyles.css';

function FeedbackForm() {
  const [validated, setValidated] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [wordCountExceeded, setWordCountExceeded] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      // Handle form submission
    }
    setValidated(true);
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
    if (event.target.value.trim().split(/\s+/).length > 200) {
      setWordCountExceeded(true);
    } else {
      setWordCountExceeded(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '75vh' }}>
      <div className="form-container" style={{ width: '50%' }}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className='mb-2'>
            <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
              <Form.Label className="form-label">First Name</Form.Label>
              <Form.Control required className="form-control" type="text" placeholder="John" />
              <Form.Control.Feedback type="invalid">Please provide a valid first name.</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='mb-2'>
            <Form.Group className="form-group" controlId="exampleForm.ControlInput2">
              <Form.Label className="form-label">Last Name</Form.Label>
              <Form.Control required className="form-control" type="text" placeholder="Doe" />
              <Form.Control.Feedback type="invalid">Please provide a valid last name.</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='mb-2'>
            <Form.Group className="form-group" controlId="exampleForm.ControlInput3">
              <Form.Label className="form-label">Email address</Form.Label>
              <Form.Control required className="form-control" type="email" placeholder="name@example.com" />
              <Form.Control.Feedback type="invalid">Please provide a valid email.</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='mb-2'>
            <Form.Group className="form-group" controlId="exampleForm.ControlTextarea1">
              <Form.Label className="form-label">Feedback Comment (Up to 200 words)</Form.Label>
              <Form.Control
                required
                className="form-control"
                as="textarea"
                rows={3}
                placeholder="Enter your feedback here"
                value={feedback}
                onChange={handleFeedbackChange}
              />
              {wordCountExceeded && <div className="text-danger">Word limit exceeded. Please limit your feedback to 200 words.</div>}
            </Form.Group>
          </div>
          <div className='d-grid mt-2'>
            <button className="btn btn-success" type="submit">Submit</button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default FeedbackForm;
